import config from '../config.js'

class Api {
  constructor (base) {
    this.baseUrl = base || config.apiUrl
  }
  getPage (page = null, arg = null) {
    let request = null

    switch (page) {
      case 'all':
      case 'meta':
      case 'playlists':
      case 'background':
      case 'radio':
      case 'objects':
        request = `${this.baseUrl}/${page}`
        break
      case 'page':
        request = arg !== null ? `${this.baseUrl}/page/${arg}` : null
        break
      case 'id':
        request = arg !== null ? `${this.baseUrl}/id=?${arg}` : null
        break
      case 'tracks':
        request = arg !== null ? `${this.baseUrl}/playlists/${arg}` : null
        break
    }
    return fetch(request).then(req => {
      if (req.status !== 200) {
        console.error(`Looks like there was a problem. Status Code: ${req.status}`)
        return
      }
      return req.json()
    }).catch(error => {
      console.error(error, {
        'Hint': 'Check configuration config.js',
        'Request': request
      })
      return error
    })
  }
}

export default Api
